module.exports = __webpack_public_path__ + "img/video-player/step-back-five-70e76d6228ace9f57578700facecf753.svg";